import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";

import FormLayout from "~/common/components/layouts/FormLayout";
import Input from "~/common/components/ui/Input";
import { INITIAL_PHONE_NUMBER } from "~/common/constants/verificationCode";
import { phoneNumberSchema } from "~/common/schemas/verificationCode";
import { PhoneNumber } from "~/common/types/verificationCode";
import { formatPhoneNumberField } from "~/common/utils";

export const PhoneVerificationNumber = ({
  isLoading,
  onCancel,
  onSubmit,
}: {
  isLoading: boolean;
  onCancel?: () => void;
  onSubmit: SubmitHandler<PhoneNumber>;
}) => {
  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm<PhoneNumber>({
    resolver: zodResolver(phoneNumberSchema),
    defaultValues: INITIAL_PHONE_NUMBER,
  });

  const submitHandler = handleSubmit((data) => {
    data.number = data.number.replace(/\D/g, "");

    return onSubmit(data);
  });

  return (
    <FormLayout
      handleGoBack={onCancel}
      handleSubmit={submitHandler}
      pendingRequest={isLoading}
      title="Mobile verification"
      description="PsychNow requires a verified mobile number as part of our commitment to account security."
      backLabel="Sign out"
      submitLabel="Continue"
    >
      <p>You will receive a verification code via SMS.</p>
      <Input
        autoFocus
        disabled={isLoading}
        error={errors.number?.message}
        placeholder="Enter mobile number"
        type="tel"
        {...formatPhoneNumberField<PhoneNumber>("number", register)}
      />
    </FormLayout>
  );
};
